import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Menu as MenuIcon,
  SavedSearch as SavedSearch,
  Search as Search,
  VideogameAsset as VideogameAsset,
  CardGiftcard as CardGiftcard,
} from "@mui/icons-material";

import Home from "./pages/Home";
import Game from "./pages/Game";
import SearchShoe from "./pages/SearchShoe"
import WinningHistory from "./pages/WinningHistory"; // Import Contact page if it exists

const menuItems = [
  { text: "Pattern Search", icon: <SavedSearch />, path: "/" },
  { text: "Search Shoe", icon: <Search />, path: "/search-shoe" },
  { text: "Game", icon: <VideogameAsset />, path: "/game" },
  { text: "Winning History", icon: <CardGiftcard />, path: "/winning-history" },
];

function AppContent() {
  const location = useLocation(); // useLocation should be inside a component under Router
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <div style={{ display: "flex" }}>
      {/* Header */}
      <AppBar position="fixed" sx={{ 
        backgroundImage: "url('/header_gold.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: '#495057'
      }} style={{ zIndex: 1201 }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" style={{ flexGrow: 1, fontWeight: '600' }}>
            Vuong Software's Baccarat
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Side Menu */}
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <div
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
          style={{ width: 250 }}
        >
          <List style={{ marginTop: "60px" }}>
            {menuItems.map((item, index) => (
              <ListItem
                button
                key={index}
                component={Link}
                to={item.path}
                style={{
                  color: '#495057', // Set text color to red
                  backgroundColor: location.pathname === item.path ? '#ccc' : 'transparent', // Highlight active menu item
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))}
          </List>
        </div>
      </Drawer>

      {/* Main Content */}
      <main style={{ flexGrow: 1, padding: "80px 20px", backgroundColor: "#ccc" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/game" element={<Game />} />
          <Route path="/search-shoe" element={<SearchShoe />} />
          <Route path="/winning-history" element={<WinningHistory />} /> {/* Add this if needed */}
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent /> {/* Ensure useLocation is inside the Router context */}
    </Router>
  );
}

export default App;
